<template>
<q-dialog
  v-model="state.show"
  persistent
>
  <div class="row" style="background:rgb(237, 238, 242);padding:10px 10px;max-width:none;position:relative;">
    <div class="col" ref="video-block" style="position:relative">
      <q-fab color="primary" icon="keyboard_arrow_right" direction="right" padding="xs" style="position:absolute;left:10px;top:10px;">
        <q-fab-action class="mqfab" color="secondary" @click="changeResolution('hd')" label="hd" padding="xs" />
        <q-fab-action class="mqfab" color="secondary" @click="changeResolution('vga')" label="vga" padding="xs" />
        <q-fab-action class="mqfab" color="secondary" @click="changeResolution('qvga')" label="qvga" padding="xs" />
      </q-fab>
      <video ref="video" id="gum-res-local" playsinline autoplay muted></video>
      
      <q-page-sticky position="bottom-right" style="position:absolute;right:10px;bottom:10px;">
        <q-btn fab icon="camera" color="accent" padding="sm" @click="capture" />
      </q-page-sticky>
    </div>

    <div v-if="state.loadingLayer.show" style="position:absolute;background:#FFFFFFAA;width:100%;height:100%;left:0px;top:0px;z-index:99999;display:flex;flex-direction:column;justify-content:center;align-items:center;">
      <q-spinner-facebook
          color="primary"
          size="2em"
        />
      {{ state.loadingLayer.message }}
    </div>
  </div>
</q-dialog>
</template>

<script>
/* eslint-disable no-unused-vars */

export default {
  props: {resolution: String},
  components: {
  },
  data: function () {
    const Vue = this
    return {
      stream: null,
      loaded: false,
      constraints: {
        qvga: {audio: false, video: {width: 320, height: 240, facingMode: "environment"}},
        vga: {audio: false, video: {width: 640, height: 480, facingMode: "environment"}},
        hd: {audio: false, video: {width: 1280, height: 720, facingMode: "environment"}}
      },
      state: {
        show: true,
        constraints: Vue.resolution,
        loadingLayer: {
          show: false,
          message: '해상도를 변경하는 중 입니다...'
        }
      }
    }
  },
  methods: {
    async capture () {
      const Vue = this
      if (Vue.loaded == true) {
        const video = this.$refs['video'];
        const canvas = document.createElement('canvas')
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
        
        const today = new Date();
        const date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
        const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        
        const f = new Promise(function (resolve, reject) {
          canvas.toBlob(function (blob) {
            try {
              const file = new File([blob], `${date}_${time}.jpg`, {type: 'image/jpeg'})
              resolve(file)
            } catch (e) {
              reject(e)
            }
            // 
          }, 'image/jpeg')
        })
        f.then((file) => {
          // console.log(file)
          Vue.$emit('oncapture', {resolution: Vue.state.constraints, file: file, aa: 123})
        }).catch((e) => {
          console.log(e)
          this.$emit('oncapture', {resolution: Vue.state.constraints})
        })
      } else
        this.$emit('oncapture', {resolution: Vue.state.constraints})
    },
    gotStream (mediaStream) {
      this.stream = window.stream = mediaStream; // stream available to console
      const video = this.$refs['video'];
      video.srcObject = mediaStream;
      const track = mediaStream.getVideoTracks()[0];
      const constraints = track.getConstraints();
      
      const videoBlock = this.$refs['video-block'];
      videoBlock.style.width = `${constraints.width}px`;
      videoBlock.style.height = `${constraints.height}px`;
      this.loaded = true
      this.state.loadingLayer.show = false
    },
    getMedia (constraints) {
      if (this.stream) {
        this.stream.getTracks().forEach(track => {
          track.stop();
        });
      }
      if (window.navigator == undefined || window.navigator.mediaDevices == undefined || window.navigator.mediaDevices.getUserMedia == undefined) {
        this.$q.notify({message: "호환 불가능한 browser / version 입니다 ", icon: 'error', color: 'purple'})
        // this.$q.notify({message: "navigator.mediaDevices.getUserMedia is undefined", icon: 'error', color: 'purple'})
        this.state.loadingLayer.show = false
        this.$emit('onerror')
      } else {
        window.navigator.mediaDevices.getUserMedia(constraints)
            .then(this.gotStream)
            .catch(e => {
              console.log(e)
              this.$q.notify({message: "카메라를 얻어오지 못했습니다", icon: 'error', color: 'purple'})
              this.state.loadingLayer.show = false
              this.$emit('onerror')
            })
      }
    },
    changeResolution: function (mode) {
      this.state.loadingLayer.show = true
      this.loaded = false
      this.state.constraints = mode
      this.getMedia(this.constraints[this.state.constraints]);
    }
  },
  mounted () {
    this.$nextTick(()=>{
      this.changeResolution(this.state.constraints);
    });
  },
  beforeDestroy () {
    if (this.stream) {
      this.stream.getTracks().forEach(track => {
        track.stop();
      });
    }
  }
}
</script>

<style>
.mqfab div.q-fab__label--internal-right {
  padding-left: 2px !important;
  padding-right: 2px !important;
  margin-top: -2px !important;
  font-size:12px;
}
</style>